import axios from "axios";
import { baseURL } from "../api/config";
export const client = axios.create({
    baseURL: baseURL,
    headers: {
        'Content-Type': 'application/json'
    },
    responseType: 'json',
});